export default __webpack_public_path__ + "static/media/card-profile6-square.fee017b5.jpg";